import FilesGallerySummary from '../../FilesGallerySummary';
import CustomFileUpload from '../FileUpload/CustomFileUpload';
import React from 'react';

/**
 * Component that displays two sections:
        - Gallery of selected files (FilesGallerySummary).
        - Component (CustomFileUpload) with two button options: 'Use Camera' and 'Upload File'.

 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 * @param string id: component identifier
 * @param model accept: file formats and sizes accepted by the component
 * @param model photoPickerFile: component model
 * @param useState setPhotoPickerFile: state to update the component model
 * @param string titleInput: title of the dashed-line component (file selection)
 * @param boolean required:  default value is false, must be set to true if the field is required
 * @param boolean disabled: for the disabled component
 * @param boolean showBtnCamera: default value is false, must be set to true if the camera option is needed
 * @param boolean validateFace: default value is false, must be set to true if face validation is required
 * @param string inputContainerClass: custom class name applied to the input container for styling purposes
 * @param boolean emptyFields: default value is false
 * @param boolean showBtnDeleteItemGallery: If true, the delete icon is displayed in the file gallery (FilesGallerySummary).
 * @param event handleStartupWebcam: Event to start the camera.,
 * @param {React.ComponentType|JSX.Element|null} [downloadIcon=null] - Custom icon for the download button (optional).
 * @param {React.ComponentType|JSX.Element|null} [deleteIcon=null] - Custom icon for the delete button (optional).
 * @param {boolean} [showBtnDownload=false] - Displays the download button in the gallery when true.
 * @param {boolean} [apiDelete=true] - If true, deletes files using an API call; otherwise deletes locally.
 *
 */
const PickerFileUploadGallery = (
    {
        id,
        accept,
        photoPickerFile,
        setPhotoPickerFile,
        titleInput = 'drag_your_file_or',
        required,
        disabled,
        showBtnCamera,
        validateFace = false,
        inputContainerClass = '',
        emptyFields,
        showBtnDeleteItemGallery,
        showBtnDownload = false,
        handleStartupWebcam,
        downloadIcon = null,
        deleteIcon = null,
        apiDelete=true
    }
) => {

    return (
        <>
            <FilesGallerySummary
                photoPickerFile={photoPickerFile}
                setPhotoPickerFile={setPhotoPickerFile}
                showBtnDeleteItemGallery={showBtnDeleteItemGallery}
                showBtnDownload={showBtnDownload}
                downloadIcon={downloadIcon}
                deleteIcon={deleteIcon}
                apiDelete={apiDelete}
                disabled={disabled}
            />

            <CustomFileUpload
                id={id}
                accept={accept}
                photoPickerFile={photoPickerFile}
                setPhotoPickerFile={setPhotoPickerFile}
                titleInput={titleInput}
                required={required}
                disabled={disabled}
                showBtnCamera={showBtnCamera}
                handleStartupWebcam={() => {
                    handleStartupWebcam();
                }}
                validateFace={validateFace}
                inputContainerClass={inputContainerClass}
                emptyFields={emptyFields}
                isMultipleFile={true}
            />
        </>
    )

}

export default PickerFileUploadGallery
